import * as React from 'react';

import {MagnifyingGlassEmptyState} from '../illustrations/magnifying-glass-empty-state';

import {EmptyStateSmall} from './empty-state-small';

import styles from './nothing-found-empty-state.module.css';

type Props = {
    title?: string;
    subtitle?: React.ReactNode | string;
    icon?: React.ReactNode;
};

export function NothingFoundEmptyState(props: Props) {
    const icon = props.icon || (
        <div className={styles['icon-container']}>
            <MagnifyingGlassEmptyState />
        </div>
    );

    return (
        <EmptyStateSmall
            title={props.title || 'Nothing found'}
            subtitle={props.subtitle || 'Try loosening your search!'}
            icon={icon}
        />
    );
}
